import React, { useState, useEffect, useRef } from "react";
import "./VideoSlider.css";

import Loader from "../Loader/Loader";

const slides = [
  {
    id: 1,
    text: "AI Banking",
    number: "AI Banking",
    para: "Enterprise-Grade AI Banking Solutions For Tomorrow's Challenges",
  },
  {
    id: 2,
    text: "Enterprise AI",
    number: "Enterprise AI",
    para: " From Information Overload to Intelligence Overflow",
  },
  {
    id: 3,
    text: "Data & Analytics",
    number: "Data & Analytics",
    para: " Intelligence That Shapes Strategy",
  },
  {
    id: 4,
    text: "Next-Gen Modernization",
    number: "Next-Gen Modernization",
    para: "Transform with Purpose: Intelligent Modernization Built by Experts",
  },
  {
    id: 5,
    text: "Cloud Innovations",
    number: "Cloud Innovations",
    para: "Beyond Banking Boundaries: From Cloud Strategy to Scalable Impact",
  },
  {
    id: 6,
    text: "Managed Cybersecurity",
    number: "Managed Cybersecurity",
    para: "Advanced Threat Protection For Today's Evolving Risk Landscape",
  },
];

const VideoSlider = ({
  videoReady,
  setVideoReady,
  videoRef,
  loading,
  setLoading,
}) => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [progress, setProgress] = useState(0);
  useEffect(() => {
    const currentDuration = 8000;

    // Reset progress to 0 at the start of each slide
    setProgress(0);

    // Update progress dynamically
    const progressInterval = setInterval(() => {
      setProgress((prev) => {
        const newProgress = prev + 100 / (currentDuration / 100);
        if (newProgress >= 100) {
          clearInterval(progressInterval);
          return 100;
        }
        return newProgress;
      });
    }, 100);

    // Automatically move to the next slide after the duration
    const slideTimeout = setTimeout(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, currentDuration);

    return () => {
      clearInterval(progressInterval);
      clearTimeout(slideTimeout);
    };
  }, [currentSlide, setVideoReady]);

  return (
    <div className="video-slider">
      {!videoReady && <Loader />}
      {/* Single Video */}
      <div className="video-overlay-wrapper h-100">
        <video
          className="video-bg"
          muted
          loop
          autoPlay
          playsInline
          webkit-playsinline="true"
          onCanPlayThrough={() => setVideoReady(true)} // Key line
          ref={videoRef}
        >
          <source src="/banner/BannerVideo.mp4" type="video/mp4" />
        </video>
        <div className="video-dark-overlay"></div>
      </div>

      {/* Slide Heading */}
      {videoReady && (
        <div className="slide-heading">
          <div className="heading-overlay">
            <h1
              className="animate-text heading"
              key={`heading-${currentSlide}`}
            >
              <span>{slides[currentSlide].number}</span>
            </h1>
            <p
              className="animate-text para bold-para"
              key={`para-${currentSlide}`}
            >
              {slides[currentSlide].para}
              <br />
            </p>
          </div>
        </div>
      )}

      {/* Progress Bars at Bottom */}
      {videoReady && (
        <div className="progress-wrapper horizontal">
          {slides.map((slide, index) => {
            return (
              <div
                key={index}
                className={`progress-item-horizontal ${
                  index === currentSlide ? "active" : "inactive"
                }`}
                onClick={() => setCurrentSlide(index)}
                style={{
                  display: index === currentSlide ? "block" : "",
                }}
              >
                <div className="progress-title">
                  <span className="">{slide.text}</span>
                </div>
                <div className="progress-track">
                  <div
                    className="progress-fill"
                    style={{
                      width: index === currentSlide ? `${progress}%` : "0%",
                    }}
                  ></div>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default VideoSlider;
